(() => {
  if (window.__airgomixFastAddToCart) return;
  window.__airgomixFastAddToCart = true;

  const ACTIVE_CLASS = 'airgomix-atc-feedback';
  const DONE_CLASS = 'airgomix-atc-done';
  const RESET_DELAY = 650;
  const FAILSAFE_DELAY = 3500;

  const style = document.createElement('style');
  style.textContent = `
    button.${ACTIVE_CLASS} {
      position: relative !important;
      overflow: hidden !important;
    }
    button.${ACTIVE_CLASS} > * {
      opacity: 0 !important;
    }
    button.${ACTIVE_CLASS}::after {
      content: attr(data-airgomix-atc-label);
      position: absolute;
      inset: 0;
      display: grid;
      place-items: center;
      padding: inherit;
      color: inherit;
      font: inherit;
      font-weight: inherit;
      letter-spacing: inherit;
      text-transform: inherit;
      background: inherit;
      pointer-events: none;
    }
    button.${ACTIVE_CLASS}[aria-busy='true']::before,
    button.${ACTIVE_CLASS} .spinner,
    button.${ACTIVE_CLASS} [class*='spinner'],
    button.${ACTIVE_CLASS} [class*='loader'] {
      display: none !important;
    }
    button.${DONE_CLASS} {
      transform: translateY(0) scale(1.008);
    }
  `;
  document.head.appendChild(style);

  const reset = (button) => {
    if (!button) return;
    button.classList.remove(ACTIVE_CLASS, DONE_CLASS);
    button.removeAttribute('data-airgomix-atc-label');
  };

  const markDone = (button) => {
    if (!button?.classList.contains(ACTIVE_CLASS)) return;
    button.dataset.airgomixAtcLabel = '✓ Im Warenkorb';
    button.classList.add(DONE_CLASS);
    window.setTimeout(() => reset(button), RESET_DELAY);
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement)) return;
    if (!form.closest('product-form')) return;
    if (!form.action.includes('/cart/add')) return;

    const button = form.querySelector('button[type="submit"]:not([disabled])');
    if (!button) return;

    button.dataset.airgomixAtcLabel = 'Wird hinzugefügt…';
    button.classList.add(ACTIVE_CLASS);

    let completed = false;
    const drawer = document.querySelector('#cart-drawer');
    const observer = drawer ? new MutationObserver(() => {
      if (completed) return;
      completed = true;
      observer.disconnect();
      markDone(button);
    }) : null;

    observer?.observe(drawer, { childList: true, subtree: true });

    window.setTimeout(() => {
      if (completed) return;
      observer?.disconnect();

      const error = form.querySelector('[role="alert"]:not(:empty), .form-control__error:not(:empty), .text-error:not(:empty)');
      if (error) {
        reset(button);
        return;
      }

      markDone(button);
    }, FAILSAFE_DELAY);
  }, true);
})();
